
import { useState } from "react";

/**
 * Custom hook for showing an approval dialog before sending a message externally.
 */
export function useApprovalDialog() {
  const [pending, setPending] = useState<{ 
    content: string, 
    resolve: (approved: boolean) => void 
  } | null>(null);

  const requestApproval = (content: string): Promise<boolean> => {
    return new Promise(resolve => {
      setPending({ content, resolve });
    });
  };

  const approve = () => {
    if (pending) pending.resolve(true);
    setPending(null);
  };
  const cancel = () => {
    if (pending) pending.resolve(false);
    setPending(null);
  };

  const ApprovalDialogUI = pending ? (
    // Lazy import to avoid double inclusion
    require("@/components/ui/ApprovalDialog").ApprovalDialog({
      open: true,
      content: pending.content,
      onApprove: approve,
      onCancel: cancel,
    })
  ) : null;

  return { requestApproval, ApprovalDialogUI };
}
